import { render } from "./Post.vue?vue&type=template&id=cc2f613c&ts=true"
import script from "./Post.vue?vue&type=script&lang=ts"
export * from "./Post.vue?vue&type=script&lang=ts"

import "./Post.vue?vue&type=style&index=0&id=cc2f613c&lang=scss"

import exportComponent from "/builds/filmin/amff-2023/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__